import { render, staticRenderFns } from "./CreateAdSpaceScreenSaver.vue?vue&type=template&id=5bc2240e&scoped=true&"
import script from "./CreateAdSpaceScreenSaver.vue?vue&type=script&lang=ts&"
export * from "./CreateAdSpaceScreenSaver.vue?vue&type=script&lang=ts&"
import style0 from "./CreateAdSpaceScreenSaver.vue?vue&type=style&index=0&id=5bc2240e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc2240e",
  null
  
)

export default component.exports